<!-- The first is handmade spinner for page changes -->
<!-- <app-spinner></app-spinner> -->
<!-- The second is a spinner that is started and stopped on any given time in the code -->
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>